import { useState } from 'react';
import { useDeleteMessage } from '../../../hooks/queries/messageQueries';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { useAuthContext } from '../../../contexts/AuthContext';

const SystemAlertDeleteModal = ({ onClose, onDeleteSuccess, selectedAlert }) => {
  const { user } = useAuthContext();
  const deleteMessage = useDeleteMessage(user?.UserSysId);
  const [isPending, setIsPending] = useState(false);
  
  const handleDelete = async () => {
    setIsPending(true);
    try {
      for (const alert of selectedAlert) {
        await deleteMessage.mutateAsync(alert);
      }
      onDeleteSuccess(selectedAlert);
    } catch (error) {
      console.error('알림 삭제 실패:', error);
      alert('알림 삭제에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header">
          <h3>알림 삭제</h3>
          <button className="close-btn" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="modal-content">
          <p className="text-b2-400 text-gray-800 my-10">{selectedAlert.length}개의 알림을 삭제하시겠습니까?</p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary big-btn w-full" onClick={handleDelete} disabled={isPending}>{isPending ? '삭제중...' : '삭제'}</button>
        </div>
      </div>
    </div>
  )
}

export default SystemAlertDeleteModal